import { Box, CircularProgress, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const ReconnectingOverlay = () => {
  const { t } = useTenantTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.55)",
        color: "#fff",
        pointerEvents: "none",
      }}
    >
      <CircularProgress size={24} sx={{ color: "#fff" }} />
      <Typography variant="body2">{t("videoReconnecting")}</Typography>
    </Box>
  );
};
